export default "__VITE_ASSET__DtLmORnL__"